import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { getWebAutoInstrumentations } from "@opentelemetry/auto-instrumentations-web";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { Resource, resourceFromAttributes } from "@opentelemetry/resources";
import { SEMRESATTRS_SERVICE_NAME } from "@opentelemetry/semantic-conventions";

const isLocalhost =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

// Deployed environments export to the same-origin ingress (/v1/traces), which
// proxies to that environment's OTel collector. This avoids CORS and prevents
// a tst/lab/prd build from pointing at the wrong collector. Local dev keeps
// the explicit endpoint from .env.
const otlpEndpoint = isLocalhost
  ? process.env.OTEL_EXPORTER_OTLP_ENDPOINT || "http://localhost:4318/v1/traces"
  : "/v1/traces";

const exporter = new OTLPTraceExporter({
  url: otlpEndpoint,
});

const provider = new WebTracerProvider({
  // @ts-ignore
  resource: resourceFromAttributes({
    [SEMRESATTRS_SERVICE_NAME]:
      process.env.OTEL_SERVICE_NAME || "intranet-frontend",
  }),
  spanProcessors: [new BatchSpanProcessor(exporter)],
});

provider.register({
  contextManager: new ZoneContextManager(),
});

registerInstrumentations({
  tracerProvider: provider,
  instrumentations: [
    getWebAutoInstrumentations({
      // load custom configuration for web instrumentations here
      "@opentelemetry/instrumentation-fetch": {
        propagateTraceHeaderCorsUrls: /.*/,
        clearTimingResources: true,
        applyCustomAttributesOnSpan: (span) => {
          span.setAttribute("app.synthetic", false);
        },
      },
    }),
  ],
});
